export default "__VITE_ASSET__166d555c__"